PegasusTemplate.Block = DS.Model.extend();

var dsAttr = DS.attr;
PegasusTemplate.Block.reopen({
  theme: DS.belongsTo(PegasusTemplate.Theme),
  presentation_order: dsAttr('number'),
  category: dsAttr('string'),
  html: dsAttr('string'),
  name: dsAttr('string'),
  preview: dsAttr('string'),
  description: dsAttr('string'),
  colCount: dsAttr('number'),
  preview_url_basic: dsAttr('string'),
  intrinsic_width: dsAttr('number'),
  media_queries: dsAttr('raw')
});
